<template>
  <div id="app">
    <router-view/>
    <!-- <div class="online-repair" @click="jumpRepair">
      <i class="el-icon-chat-dot-round" :style="{fontSize: '16px', color: '#fff', marginLeft: '2px'}"></i>
      在线运维
    </div> -->
  </div>
</template>

<script>
import {getSession } from '@/utils/auth.js'
import { savePoint } from '@/api/tao.js'
export default {
  name: 'App',
  data() { 
    return {
      timer: null
    }
  },
  methods: {
    jumpRepair() {
      // let url = `http://175.24.112.37:8035/im/index.html?appid=1xoadw&orgi=cskefu&client=&aiid=&userid=${getSession('name')}&userName=${getSession('realName')}--ma--${getSession('shopName')}&sessionid=&title=百秋自动化平台&traceid=&url=http://localhost:8001/?#/login&t=1657633360644`
      let url = `https://softwareops.ibaiqiu.cn/im/index.html?appid=1p5ahk&orgi=cskefu&client=&aiid=&userid=${getSession('name')}&userName=${getSession('realName')}--ma--${getSession('shopName')}&sessionid=&title=百秋自动化平台&traceid=&url=http://localhost:8001/?#/login&t=1657633360644`
      window.open(url, '_blank', 'width=850,height=610')
    },
    savePoint() {
      console.log('设置埋点');
      let pointList = JSON.parse(localStorage.getItem('ma-point-list') || '[]')
      if (!pointList.length) return
      savePoint(pointList)
      localStorage.removeItem('ma-point-list')
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.savePoint()
    }, 1000 * 60 * 1)
  },
  beforeDestroy() {
    this.savePoint()
    if (this.timer) clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.online-repair{
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 10;
  width: 30px;
  padding: 10px 5px;
  text-align: center;
  background-color: #ED6C73;
  border-radius: 15px;
  color: #fff;
  font-size: 12px;
  line-height: 1.5;
  cursor: pointer;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue